<div *ngIf="user" class="d-flex flex-column">
  <div
    matBadge="&#8288;"
    matBadgeColor="accent"
    [matBadgeHidden]="!newProfilePicture"
    matBadgeSize="small"
    class="rounded border p-3 mt-3 mb-4 d-flex flex-column align-items-center"
  >
    <div *ngIf="user.profilePicture && !newProfilePicture" class="text-center">
      <img class="profile-picture" [src]="user.profilePicture" />
      <h5 class="mat-body mt-3 mb-4">Your current profile picture</h5>
    </div>
    <app-media-upload
      class="w-100"
      [allowedMimeTypes]="['image/png', 'image/jpeg', 'image/jpg']"
    ></app-media-upload>
    <button
      *ngIf="newProfilePicture"
      mat-flat-button
      color="accent"
      (click)="saveNewProfilePicture()"
      [disabled]="isUpdatingProfilePicture"
    >
      Upload and save
    </button>
  </div>

  <mat-form-field
    appearance="outline"
    matBadge="&#8288;"
    matBadgeColor="accent"
    [matBadgeHidden]="displayName === user.displayName"
    matBadgeSize="small"
  >
    <mat-label>Display Name</mat-label>
    <input
      matInput
      type="text"
      [value]="displayName"
      (input)="
        displayName = getValueFromEventTarget($event.target) ?? '';
        detectIfChanges()
      "
    />
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    matBadge="&#8288;"
    matBadgeColor="accent"
    [matBadgeHidden]="biography === user.biography"
    matBadgeSize="small"
  >
    <mat-label>Biography</mat-label>
    <textarea
      matInput
      placeholder="Write your Bio here..."
      [value]="biography"
      (input)="
        biography = getValueFromEventTarget($event.target) ?? '';
        detectIfChanges()
      "
    ></textarea>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    matBadge="&#8288;"
    matBadgeColor="accent"
    [matBadgeHidden]="startDate === user.startDate"
    matBadgeSize="small"
  >
    <mat-label>Start Date</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [value]="startDate"
      (dateChange)="startDate = $event.target.value; detectIfChanges()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint
      >This is the date you started practicing Parkour and Freerunning. It will
      be rounded to full years after one year or more so don't sweat
      it.</mat-hint
    >
  </mat-form-field>
</div>
<div *ngIf="!user" class="d-flex justify-content-center w-100 p-5">
  <mat-spinner color="accent"></mat-spinner>
</div>
